import { INVENTORY_MODULE } from "@/api_framework/api_config";
import { IGroupItemsUpdatePutBody, IGroupItemsUpdatePutResponse } from "@/api_framework/api_modals/Inventory";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";

AxiosCurlirize(axios, () => {});

export const useGroupItemsUpdateAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();

  const execute = useCallback(
    async (filterParams: IGroupItemsUpdatePutBody, id: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        await axios
          .put(INVENTORY_MODULE?.GROUP_ITEMS_UPDATE?.baseURL + `${id}`, filterParams, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IGroupItemsUpdatePutResponse>) => {
            if (res.data.status === true) {
              toast.success("Group Item has been updated ");
            } else {
              return { status: false, message: "batch_not_created" };
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            captureError(e);
          });
      } catch (e: any) {
        toast.error("Server Error: " + e.message);
      }
    },
    [dispatch],
  );
  return { execute };
};
